import { render, staticRenderFns } from "./PassgerPage.vue?vue&type=template&id=4f031eae&scoped=true"
import script from "./PassgerPage.vue?vue&type=script&lang=js"
export * from "./PassgerPage.vue?vue&type=script&lang=js"
import style0 from "./PassgerPage.vue?vue&type=style&index=0&id=4f031eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f031eae",
  null
  
)

export default component.exports